import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'redux-zero/react';
import { PageHeader, PageTitle, Button } from '@tokenyico/tokeny-ui';
import { DsExplorerLink, DsLogo } from '@tokenyico/design-system/dist/reactJS';
import { dateFormat } from '@tokenyico/design-system';
import { getPep, TypeOfInvestorIcon } from 'app/helpers/investor';

const ProfileBasicInfoView = ({ history, investor, selectedToken }) => {
  const { t } = useTranslation();
  const investorType = investor.typeOfInvestor;

  const walletStatus = investor.walletsAndStatus.find(
    (w) => w.identityRegistryStorage === selectedToken.identityRegistryStorage,
  );

  return (
    <div className="basic-info sidebar _m:left(2)">
      <PageHeader>
        <PageTitle>
          <h1 className="h3 _m:bottom(2)"> {t('shared.profile')}</h1>
          <Button
            version="primary"
            label={t('shared.edit')}
            type="button"
            icon="Pencil"
            isReverse={true}
            iconHeight={11}
            onClick={() => history.push('/profile/basic-info/edit')}
          />
        </PageTitle>
      </PageHeader>
      <div>
        {investorType === 'institution' ? (
          <ul className="investor-details">
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.tradeName')}</div>
              <div>{investor.institutional.institutionTradeName || '-'}</div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.legalName')}</div>
              <div>{investor.institutional.institutionLegalName || '-'}</div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.email')}</div>
              <div>{investor.email || '-'}</div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">
                <DsLogo name="onchainid" style={{ width: '6rem' }} />
              </div>
              <div>
                <DsExplorerLink
                  address={investor.identityAddress || '-'}
                  network={selectedToken.blockchainNetwork}
                  type="onchainid"
                />
              </div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title _flex:align(center)">
                {walletStatus.provider === 'ONCHAINID' && (
                  <DsLogo name="onchainid" style={{ width: '6rem' }} />
                )}
                {t('shared.wallet')}
              </div>

              <div>
                <DsExplorerLink
                  address={walletStatus.wallet || '-'}
                  network={selectedToken.blockchainNetwork}
                />
              </div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.typeOfInvestor')}</div>
              <div style={{ textTransform: 'capitalize' }}>
                <span className="_p:right(2)">
                  <TypeOfInvestorIcon investor={investor} size={12} />
                </span>
                {investor.typeOfInvestor || '-'}
              </div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.registryNumber')}</div>
              <div>{investor.institutional.institutionRegistryNumber || '-'}</div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.registryCountry')}</div>
              <div>{investor.institutional.institutionRegistryCountry || '-'}</div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.activity')}</div>
              <div>{investor.institutional.institutionActivity || '-'}</div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.incorporationDate')}</div>
              <div>
                {investor.institutional.institutionIncorporationDate
                  ? dateFormat(investor.institutional.institutionIncorporationDate, true)
                  : '-'}
              </div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.legalForm')}</div>
              <div>{investor.institutional.institutionLegalForm || '-'}</div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.countryOfIncorporation')}</div>
              <div>{investor.institutional.institutionCountry || '-'}</div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.city')}</div>
              <div>{investor.institutional.institutionCity || '-'}</div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.street')}</div>
              <div>{investor.institutional.institutionStreet || '-'}</div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.buildingNumber')}</div>
              <div>{investor.institutional.institutionBuildingNumber || '-'}</div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.state')}</div>
              <div>{investor.institutional.institutionState || '-'}</div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.zipCode')}</div>
              <div>{investor.institutional.institutionZipCode || '-'}</div>
            </li>
          </ul>
        ) : null}

        {investorType === 'individual' ? (
          <ul className="investor-details">
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.firstName')}</div>
              <div>{investor.individual.firstName || '-'}</div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.lastName')}</div>
              <div>{investor.individual.lastName || '-'}</div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.email')}</div>
              <div>{investor.email || '-'}</div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">
                <DsLogo name="onchainid" style={{ width: '6rem' }} />
              </div>
              <div>
                <DsExplorerLink
                  address={investor.identityAddress || '-'}
                  network={selectedToken.blockchainNetwork}
                  type="onchainid"
                />
              </div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title _flex:align(center)">
                {walletStatus.provider === 'ONCHAINID' && (
                  <DsLogo name="onchainid" style={{ width: '6rem' }} />
                )}
                {t('shared.wallet')}
              </div>
              <div>
                <DsExplorerLink
                  address={walletStatus.wallet || '-'}
                  network={selectedToken.blockchainNetwork}
                />
              </div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.typeOfInvestor')}</div>
              <div style={{ textTransform: 'capitalize' }}>
                <span className="_p:right(2)">
                  <TypeOfInvestorIcon investor={investor} size={12} />
                </span>
                {investor.typeOfInvestor || '-'}
              </div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.gender')}</div>
              <div>{investor.individual.gender || '-'}</div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.dateOfBirth')}</div>
              <div>
                {investor.individual.birthday
                  ? dateFormat(investor.individual.birthday, true)
                  : '-'}
              </div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.birthplace')}</div>
              <div>{investor.individual.birthplace || '-'}</div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.nationality')}</div>
              <div>{investor.individual.nationality || '-'}</div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.occupationalSector')}</div>
              <div>{investor.individual.occupation || '-'}</div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.countryOfResidence')}</div>
              <div>{investor.individual.country || '-'}</div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.state')}</div>
              <div>{investor.individual.state || '-'}</div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.city')}</div>
              <div>{investor.individual.city || '-'}</div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.street')}</div>
              <div>{investor.individual.street || '-'}</div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.buildingNumber')}</div>
              <div>{investor.individual.buildingNumber || '-'}</div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.zipCode')}</div>
              <div>{investor.individual.zipCode || '-'}</div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.passportNumber')}</div>
              <div>{investor.individual.passportNumber || '-'}</div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.idNumber')}</div>
              <div>{investor.individual.idNumber || '-'}</div>
            </li>
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.phoneNumber')}</div>
              <div>{investor.individual.phone || '-'}</div>
            </li>
            {/* <li className="investor-details__group-information"> */}
            {/*   <div className="investor-details__title">{t('shared.ssnNumber')}</div> */}
            {/*   <div>{investor.individual.ssnNumber || '-'}</div> */}
            {/* </li> */}
            <li className="investor-details__group-information">
              <div className="investor-details__title">{t('shared.politicallyExposedPerson')}</div>
              <div style={{ textTransform: 'capitalize' }}>{getPep({ investor })}</div>
            </li>
          </ul>
        ) : null}
      </div>
    </div>
  );
};

const mapToProps = ({ holder: { user, selectedToken } }) => ({ investor: user, selectedToken });

export default connect(mapToProps)(ProfileBasicInfoView);
